import React from "react";
import { useRouter } from "next/router";
import ProjectCard from "./sharedSections/ProjectCard";
import { useTranslations } from "next-intl";
export default function index({ data }) {
  const { locale } = useRouter();
  const t = useTranslations("projects");

  return (
    <>
      <div className=" flex flex-wrap justify-center mds:gap-[50px] gap-[16px]  w-[90%] max-w-[91rem] m-auto  relative   mds:mt-[82px] mt-[32px] ">
        {data?.map((project) => {
          return (
            <ProjectCard
              link={`${project?.link}`}
              bgColor={project?.color}
              projectName={project[locale].projectName}
              lineColor={project?.lineColor}
              img={project?.img}
              btn_color={project?.btn_color}
              colorAfter={project?.colorAfter}
              slug={project?.slug}
              data={data}
              sliderImage={project?.sliderImage}
            />
          );
        })}
      </div>
    </>
  );
}
